import React from 'react';
import { history } from 'umi';

import styles from '../styles.scss';

export default (props) => {

  const {buttonList} = props;

  return(
    <div className={styles.button_box}>

      {buttonList.map(item => (
        <div key={item.id} className={styles.button_item}
             onClick={()=>{
                history.push('/program/programDetail?programId=' + item.columnId + '&title=' + item.zyColumn.name);
             }}>
          {item.zyColumn.name}
        </div>
      ))}
    </div>
  )
}
